import { render, staticRenderFns } from "./BdQuality.vue?vue&type=template&id=27b5d22c&"
import script from "./BdQuality.vue?vue&type=script&lang=js&"
export * from "./BdQuality.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports